module.exports = __webpack_public_path__ + "static/media/icon-circle-fb.676cf16d.svg";